import React, { PureComponent, createRef } from 'react';

import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';

import { USER_TAB } from 'constants/form';

import CreateTeacher from './user';
import CreateProfile from './profile';
import CreateSlot from './slot';

const FullFlexView = styled(FlexView)`
  width: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
`;

const Progress = styled.div`
  width: ${({ width }) => width}%;
  height: 5px;
  background-color: blue;
  margin-bottom: 30px;
  transition: width 1s;
`;

const RefElement = styled.div`
  width: 0;
  height; 0;
`;

export default class TeacherFormView extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollRef = createRef();
  }

  componentDidUpdate() {
    this.scrollRef.current.scrollIntoView({ block: 'start' });
  }

  renderForm = () => {
    const { tab } = this.props;

    switch (tab) {
      case USER_TAB.ACCOUNT:
        return <CreateTeacher {...this.props} />;
      case USER_TAB.PROFILE:
        return <CreateProfile {...this.props} />;
      case USER_TAB.SLOTS:
        return <CreateSlot {...this.props} />;
      default:
        return null;
    }
  };

  render() {
    const { tab } = this.props;
    const progressBarWidth = ((tab + 1) * 100) / (Object.keys(USER_TAB).length - 1);

    return (
      <FullFlexView>
        <RefElement ref={this.scrollRef} />
        <CardWrapper>
          {tab !== 2 && <Progress width={progressBarWidth} />}
          {this.renderForm()}
        </CardWrapper>
      </FullFlexView>
    );
  }
}
